/* unplugin-vue-components disabled */import script from "./NewComer.vue?vue&type=script&setup=true&lang=js"
export * from "./NewComer.vue?vue&type=script&setup=true&lang=js"

import "./NewComer.vue?vue&type=style&index=0&id=387d3c5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-387d3c5a"]])

export default __exports__